/* global elementorFrontend */
S.sliderModule = {
    elements: {
        $slickWrapper: null,
    },
    init()
    {
        // No slider found
        if (!this.elements.$slickWrapper.length)
        {
            return;
        }
        if (elementorFrontend.isEditMode() === false)
        {
            this.initSlider(this.elements.$slickWrapper);
        }
    },

    initSlider(slider)
    {
        const slideCount = slider.find('.m-picture').length;
        if (slideCount <= 1)
        {
            return;
        }

        // Initialize new slider
        slider.slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            dots: true,
            arrows: false,
        });
    },
};


// Elementor Preview
jQuery(window).on('elementor/frontend/init', function ()
{
    elementorFrontend.hooks.addAction(
        'frontend/element_ready/slidermodule.default',
        function ($scope)
        {
            // FIND SLIDER DIRECTLY
            const $slider = $scope.find('.js-slick-wrapper');
            if ($slider.length)
            {
                S.sliderModule.$slider = $slider;
                S.sliderModule.initSlider($slider);
            }
        },
    );
});
